import * as tslib_1 from "tslib";
import { AssetBase } from "@awayjs/core";
import { TesselatedFontTable } from "./TesselatedFontTable";
import { BitmapFontTable } from "./BitmapFontTable";
/**
 * Font is a container for FontTables.
 *
 *
 *
 */
var Font = (function (_super) {
    tslib_1.__extends(Font, _super);
    //TODO test shader picking
    //		public get shaderPickingDetails():boolean
    //		{
    //
    //			return this.sourceEntity.shaderPickingDetails;
    //		}
    /**
     * Creates a new TesselatedFont object
     */
    function Font() {
        var _this = _super.call(this) || this;
        _this._font_styles = [];
        // ------------ dummys for as3web:
        _this.fontName = null;
        return _this;
    }
    Font.registerFont = function (any) {
    };
    Object.defineProperty(Font.prototype, "font_styles", {
        // ------------
        get: function () {
            return this._font_styles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Font.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return Font.assetType;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    Font.prototype.dispose = function () {
        var len = this._font_styles.length;
        for (var i = 0; i < len; ++i) {
            this._font_styles[i].dispose();
        }
        this._font_styles.length = 0;
    };
    /**
     *Get a font-table for a specific name, or create one if it does not exists.
     */
    Font.prototype.get_font_table = function (style_name, assetType, openTypeFont) {
        if (assetType === void 0) { assetType = TesselatedFontTable.assetType; }
        if (openTypeFont === void 0) { openTypeFont = null; }
        var len = this._font_styles.length;
        //console.log("font name", this.name, style_name);
        for (var i = 0; i < len; ++i) {
            if ((this._font_styles[i].assetType == assetType) && (this._font_styles[i].name == style_name)) {
                // mak
                return this._font_styles[i];
            }
        }
        var font_style = null;
        if (assetType == TesselatedFontTable.assetType) {
            font_style = new TesselatedFontTable(openTypeFont);
        }
        else if (assetType == BitmapFontTable.assetType) {
            font_style = new BitmapFontTable();
        }
        font_style.name = style_name;
        this._font_styles.push(font_style);
        return font_style;
    };
    return Font;
}(AssetBase));
export { Font };
Font.assetType = "[asset Font]";



// WEBPACK FOOTER //
// ../dist/lib/text/Font.js